import React, { FC } from 'react';
import { useCardRoutes } from '../../hooks/useCardRoutes';
import { useFilters } from '../../hooks/useFilters';
import CardsNavButtons from '../CardsNavButtons/CardsNavButtons';

interface ITab {
  name: string;
  value: string;
}

interface ICardsReports {tabs: ITab[]}
const CardsReports:FC<ICardsReports> = ({tabs}) => {
  const {currentFilters, applyFilters} = useFilters();
  const {allFiltersClearedObj, goBackToCard, isBackButtonVisible } = useCardRoutes();
  const changeCard = (card: string) => {
    const clearedFilters = {
      ...allFiltersClearedObj,
      card
    };
    applyFilters(clearedFilters);
  };

  return (<div>
    <CardsNavButtons
      tabs={tabs}
      changeActiveTab={changeCard}
      activeTab={(currentFilters?.card as string) || 'results'}
      backMethod={goBackToCard}
      backButtonVisible={isBackButtonVisible}
    />
  </div>);
};
export default CardsReports;
